import { PrivateInterceptor } from '../../Base/interceptors/PrivateInterceptor'

export const getStyleCategory = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getStyleCategory`, 'GET');
    return result;
}

export const getYarnTitle = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getYarnTitle`, 'GET');
    return result;
}

export const getFabricStyles = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getFabricStyles`, 'GET');
    return result;
}

export const getDyeType = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getDyeType`, 'GET');
    return result;
}

export const getDensity = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getDensity`, 'GET');
    return result;
}

export const getYarn = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getYarn`, 'GET');
    return result;
}

export const getYarnDetails = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getYarnDetails`, 'GET');
    return result;
}

export const getCalibres = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getCalibres`, 'GET');
    return result;
}

export const getTypes = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getTypes`, 'GET');
    return result;
}

export const getTypesCotton = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getTypesCotton`, 'GET');
    return result;
}

export const getEfectos = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getEfectos`, 'GET');
    return result;
}

export const getFibras = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getFibras`, 'GET');
    return result;
}

export const getCross = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getCross`, 'GET');
    return result;
}

export const getRecycled = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getRecycled`, 'GET');
    return result;
}

export const getLoster = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getLoster`, 'GET');
    return result;
}

export const getTypesPoly = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getTypesPoly`, 'GET');
    return result;
}

export const getYarnDetailsPorID = (IdYarnTitle) => {
    const respuesta = PrivateInterceptor("Desarrollo/getYarnDetailsPorID", "POST", {IdYarnTitle});
    return respuesta;
};

//----------------------------------------------------------------------------------------------------------------

export const GuardarYarnTitle = (Datos) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarYarnTitle", "POST", {Datos});
    return respuesta;
};

export const EditarYarnTitle = (Datos) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarYarnTitle", "POST", {Datos});
    return respuesta;
};


export const GuardarFabricStyle = (Datos) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarFabricStyle", "POST", {Datos});
    return respuesta;
};

export const EditarFabricStyle = (Datos) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarFabricStyle", "POST", {Datos});
    return respuesta;
};


export const EditarDyeType = (Datos) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarDyeType", "POST", {Datos});
    return respuesta;
};

export const GuardarDyeType = (Datos) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarDyeType", "POST", {Datos});
    return respuesta;
};


export const EditarDensity = (Datos) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarDensity", "POST", {Datos});
    return respuesta;
};

export const GuardarDensity = (Datos) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarDensity", "POST", {Datos});
    return respuesta;
};

export const GuardarYarnCotton = (DatosEncabezado, DatosDetalle) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarYarnCotton", "POST", {DatosEncabezado, DatosDetalle});
    return respuesta;
};

export const EditarYarnCotton = (DatosEncabezado, DatosDetalle) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarYarnCotton", "POST", {DatosEncabezado, DatosDetalle});
    return respuesta;
};

export const GuardarYarnSinthetic = (DatosEncabezado) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarYarnSynthetic", "POST", {DatosEncabezado});
    return respuesta;
};

export const EditarYarnSynthetic = (DatosEncabezado) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarYarnSynthetic", "POST", {DatosEncabezado});
    return respuesta;
};

export const GuardarYarnSpandex = (DatosEncabezado) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarYarnSpandex", "POST", {DatosEncabezado});
    return respuesta;
};

export const EditarYarnSpandex = (DatosEncabezado) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarYarnSpandex", "POST", {DatosEncabezado});
    return respuesta;
};

export const EliminarYarn = (DatosEncabezado) => {
    const respuesta = PrivateInterceptor("Desarrollo/EliminarYarn", "POST",{DatosEncabezado});
    return respuesta;
};

export const GuardarCalibre = (DatosCalibre) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarCalibre", "POST", {DatosCalibre});
    return respuesta;
};

export const EditarCalibre = (DatosCalibre) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarCalibre", "POST", {DatosCalibre});
    return respuesta;
};

export const GuardarType = (DatosType) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarType", "POST", {DatosType});
    return respuesta;
};

export const EditarType = (DatosType) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarType", "POST", {DatosType});
    return respuesta;
};

export const GuardarEfecto = (DatosEfecto) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarEfecto", "POST", {DatosEfecto});
    return respuesta;
};

export const EditarEfecto = (DatosEfecto) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarEfecto", "POST", {DatosEfecto});
    return respuesta;
};

export const GuardarFibra = (DatosFibra) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarFibra", "POST", {DatosFibra});
    return respuesta;
};

export const EditarFibra = (DatosFibra) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarFibra", "POST", {DatosFibra});
    return respuesta;
};

export const GuardarTypesC = (DatosTypesC) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarTypesC", "POST", {DatosTypesC});
    return respuesta;
};

export const EditarTypesC = (DatosTypesC) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarTypesC", "POST", {DatosTypesC});
    return respuesta;
};

export const GuardarLoster = (DatosLoster) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarLoster", "POST", {DatosLoster});
    return respuesta;
};

export const EditarLoster = (DatosLoster) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarLoster", "POST", {DatosLoster});
    return respuesta;
};

export const GuardarRecycled = (DatosRecycled) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarRecycled", "POST", {DatosRecycled});
    return respuesta;
};

export const EditarRecycled = (DatosRecycled) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarRecycled", "POST", {DatosRecycled});
    return respuesta;
};

export const GuardarCross = (DatosCross) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarCross", "POST", {DatosCross});
    return respuesta;
};

export const EditarCross = (DatosCross) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarCross", "POST", {DatosCross});
    return respuesta;
};

export const EliminarYarnDetail = (DatosDetalle) => {
    const respuesta = PrivateInterceptor("Desarrollo/EliminarYarnDetail", "POST",{DatosDetalle});
    return respuesta;
};

export const EliminarYarnDetail2 = (DatosDetalle) => {
    const respuesta = PrivateInterceptor("Desarrollo/EliminarYarnDetail2", "POST",{DatosDetalle});
    return respuesta;
};

export const GuardarTypesP = (DatosTypesS) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarTypesP", "POST", {DatosTypesS});
    return respuesta;
};

export const EditarTypesP = (DatosTypesS) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarTypesP", "POST", {DatosTypesS});
    return respuesta;
};

export const ObtenerSiguienteCorrelativoC = () => {
    const respuesta = PrivateInterceptor("Desarrollo/ObtenerSiguienteCorrelativoC", "GET");
    return respuesta;
};

export const ObtenerSiguienteCorrelativoS = () => {
    const respuesta = PrivateInterceptor("Desarrollo/ObtenerSiguienteCorrelativoS", "GET");
    return respuesta;
};

export const getHilaza = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getHilaza`, 'GET');
    return result;
}

export const AgregarHilaza = (IdProductoSuministro, IdYarnDev) => {
    const respuesta = PrivateInterceptor("Desarrollo/AgregarHilaza", "POST", {IdProductoSuministro, IdYarnDev});
    return respuesta;
};

export const CambiarEstado = (IdProductoSuministro, IdEstado) => {
    const respuesta = PrivateInterceptor("Desarrollo/CambiarEstado", "POST", {IdProductoSuministro, IdEstado});
    return respuesta;
};